import React from 'react';
import { useTranslation } from 'react-i18next';

import { MediaDevices } from 'icons/untitledui';

import * as Buttons from 'theme/components/Buttons.style';
import * as Styled from 'shiftNotes/styles/NoteCaptureRecording.style';

interface RecordingPausedChipProps {
  onResume: () => void;
}

export default function RecordingPausedChip({
  onResume,
}: RecordingPausedChipProps): JSX.Element {
  const { t } = useTranslation('pageShiftNotes');

  return (
    <Styled.PausedStack>
      <Styled.PausedTitle>
        {t('noteCaptureRecording.paused')}
      </Styled.PausedTitle>
      <Buttons.SecondaryLight
        $size="small"
        onClick={onResume}
        data-testid="note-capture-resume-button"
      >
        <MediaDevices.Play />
        {t('noteCaptureRecording.resume')}
      </Buttons.SecondaryLight>
    </Styled.PausedStack>
  );
}
